import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { crearProveedor } from '../../actions/proveedores';
import { editarBreadcrumb } from '../../actions/breadcrumb';

const NuevoProveedor = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [proveedorData, setProveedorData] = useState({
        nombre: null,
        correo: null,
        direccion: null,
        telefono: null,
        rfc: null,
        contacto: null
    });

    const [statusProcesar, setStatusProcesar] = useState(false);

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { nombre: 'Proveedores', path: '/proveedores', activo: false },
            { nombre: 'Nuevo proveedor', path: '/proveedores/nuevo', activo: true }
        ]));
    }, []);

    const handleInputChange = ({ target }) => {
        setProveedorData({ ...proveedorData, [target.name]: target.value });
    };

    const handleSubmit = async () => {
        setStatusProcesar(true);
        await dispatch(crearProveedor(proveedorData));
        setStatusProcesar(false);
        navigate('/proveedores');
    };

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Nuevo proveedor</h4>
            </div>

            <div className="col-12">
                <div className="accordion" id="accordionNuevoProveedor">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingInfo">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseInfo" aria-expanded="true" aria-controls="collapseInfo">
                                Información del proveedor
                            </button>
                        </h2>
                        <div id="collapseInfo" className="accordion-collapse collapse show" aria-labelledby="headingInfo" data-bs-parent="#accordionNuevoProveedor">
                            <div className="accordion-body">
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Nombre"
                                                id="nombre"
                                                name="nombre"
                                                value={proveedorData.nombre || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="nombre">Nombre</label>
                                        </div>
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Dirección"
                                                id="direccion"
                                                name="direccion"
                                                value={proveedorData.direccion || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="direccion">Dirección</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Correo"
                                                id="correo"
                                                name="correo"
                                                value={proveedorData.correo || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="correo">Correo</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Teléfono"
                                                id="telefono"
                                                name="telefono"
                                                value={proveedorData.telefono || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="telefono">Teléfono</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="RFC"
                                                id="rfc"
                                                name="rfc"
                                                value={proveedorData.rfc || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="rfc">RFC</label>
                                        </div>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <div className="form-floating">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Contacto"
                                                id="contacto"
                                                name="contacto"
                                                value={proveedorData.contacto || ''}
                                                onChange={handleInputChange}
                                            />
                                            <label htmlFor="contacto">Contacto</label>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-secondary me-2" onClick={() => navigate('/proveedores')} disabled={statusProcesar}>
                    Cancelar
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-success" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Guardando</button>
                        : <button className="btn btn-success" onClick={handleSubmit}><i className="fas fa-check me-1"></i> Guardar</button>
                }
            </div>
        </div>
    );
};

export default NuevoProveedor;
